import { useState } from 'react';
import Typewriter from 'typewriter-effect';
import { Link } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import SubscribedResources from "../components/SubscribedResources";
import {
  FaSearch,
  FaBars,
  FaTimes,
  FaDatabase,
  FaAngleDown,
  FaBookmark,
  FaHistory,
  FaUser,
  FaBookOpen, 
  FaNewspaper, 
  FaFileAlt, 
  FaPenFancy, 
  FaLayerGroup, 
  FaTabletAlt,
  FaVideo,
  FaFileSignature,
} from "react-icons/fa";
import CountUp from 'react-countup';

const filters = [
  'All',
  'Journal Articles',
  'eJournals',
  'eBooks',
  'Theses',
  'Multimedia',
  'Pre-Prints',
  'Newspapers',
  'Magazines'
];

export default function EnhancedDashboard() {
  const [menuOpen, setMenuOpen] = useState({});
  const [selectedFilters, setSelectedFilters] = useState(['All']);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMenu = (key) => {
    setMenuOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const toggleFilter = (filter) => {
    if (filter === 'All') {
      setSelectedFilters(['All']);
    } else {
      const updated = selectedFilters.includes(filter)
        ? selectedFilters.filter((f) => f !== filter)
        : [...selectedFilters.filter((f) => f !== 'All'), filter];
      setSelectedFilters(updated);
    }
  };

  const profileRef = useRef();

useEffect(() => {
  const handleClickOutside = (event) => {
    if (profileRef.current && !profileRef.current.contains(event.target)) {
      setMenuOpen(prev => ({ ...prev, profile: false }));
    }
  };
  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);


const subscribedResources = [
    {
      category: "E-Journals",
      publishers: ["J-Gate", "Springer", "Wiley Online Library"]
    },
    {
      category: "E-Books",
      publishers: ["ProQuest", "EBSCO", "Oxford Academic"]
    },
    {
      category: "Databases",
      publishers: ["Scopus", "PubMed", "Web of Science"]
    }
  ];
  
const stats = [
  { label: 'Journal Articles', value: 100000000, icon: <FaNewspaper /> },
  { label: 'Journals', value: 90000, icon: <FaBookOpen /> },
  { label: 'Theses', value: 1200000, icon: <FaFileAlt /> },
  { label: 'Pre-Prints', value: 2200000, icon: <FaPenFancy /> },
  { label: 'Book Chapters', value: 200000, icon: <FaLayerGroup /> },
  { label: 'eBooks', value: 100000, icon: <FaTabletAlt /> },
  { label: 'Multimedia', value: 120000, icon: <FaVideo /> },
  { label: 'Conference Papers', value: 220000, icon: <FaFileSignature /> },
];

  return (
    <div className="min-h-screen flex bg-gray-50">
      {/* Sidebar */}
      <aside className="hidden md:flex md:w-1/6 h-screen sticky top-0 bg-gradient-to-b from-[#044f5c] to-[#066a75] text-white p-4 flex-col overflow-y-auto scrollbar-thin scrollbar-thumb-orange-500 scrollbar-track-[#044e57]">
      {/* Institution Logo */}
      <div className="mb-6 flex justify-center">
        <div className="w-28 h-29 rounded-xl overflow-hidden shadow-lg">
        <img
          src="/testimonials/college_logo.png"
          alt="Institution Logo"
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
        />
        </div>
      </div>
      <p className="text-center text-sm font-medium text-white mt-2 uppercase tracking-wide">
          International College Academy
        </p>

      {/* Scrollable Menu */}
      <div className="overflow-y-auto scrollbar-thin scrollbar-thumb-orange-500 scrollbar-track-[#044e57] flex-1 space-y-6 pr-2">
        <br />

        {/* Digital Library Section */}
        <div>
          <button
            className="flex justify-between items-center w-full font-medium hover:text-[#ff7a00]"
            onClick={() => toggleMenu('library')}
          >
            <span className="flex items-center gap-2">
              <FaBookOpen /> 
              <span className="hidden md:inline">Digital Library</span>
            </span>
            <FaAngleDown className={`transition-transform ${menuOpen['library'] ? 'rotate-180' : ''}`} />
          </button>
          <div
            className={`transition-all duration-300 overflow-hidden ${
              menuOpen['library'] ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <ul className="pl-6 mt-2 space-y-2 text-sm">
              <li className="hover:text-[#ff7a00] cursor-pointer">eBooks</li>
              <li className="hover:text-[#ff7a00] cursor-pointer">Journals</li>
              <li className="hover:text-[#ff7a00] cursor-pointer">Theses</li>
              <li className="hover:text-[#ff7a00] cursor-pointer">Pre-Prints</li>
              <li className="hover:text-[#ff7a00] cursor-pointer">Book Chapters</li>
              <li className="hover:text-[#ff7a00] cursor-pointer">Multimedia</li>
              <li className="hover:text-[#ff7a00] cursor-pointer">Conference Papers</li>
            </ul>
          </div>
        </div>

        {/* Subscribed Resources Section */}
        <div>
          <button
            className="flex justify-between items-center w-full font-medium hover:text-[#ff7a00]"
            onClick={() => toggleMenu('databases')}
          >
            <span className="flex items-center gap-2">
              <FaDatabase /> 
              <span className="hidden md:inline">Databases</span>
            </span>
            <FaAngleDown className={`transition-transform ${menuOpen['databases'] ? 'rotate-180' : ''}`} />
          </button>
          <div
            className={`transition-all duration-300 overflow-hidden ${
              menuOpen['databases'] ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <ul className="pl-6 mt-2 space-y-2 text-sm">
              <li className="hover:text-[#ff7a00] cursor-pointer">J-Gate</li>
              <li className="hover:text-[#ff7a00] cursor-pointer">EBSCO</li>
              <li className="hover:text-[#ff7a00] cursor-pointer">ProQuest</li>
              <li className="hover:text-[#ff7a00] cursor-pointer">JSTOR</li>
            </ul>
          </div>
        </div>

        {/* My Account Section */}
        <div>
          <button
            className="flex justify-between items-center w-full font-medium hover:text-[#ff7a00]"
            onClick={() => toggleMenu('account')}
          >
            <span className="flex items-center gap-2">
              <FaUser /> 
              <span className="hidden md:inline">My Account</span>
            </span>
            <FaAngleDown className={`transition-transform ${menuOpen['account'] ? 'rotate-180' : ''}`} />
          </button>
          <div
            className={`transition-all duration-300 overflow-hidden ${
              menuOpen['account'] ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <ul className="pl-6 mt-2 space-y-2 text-sm">
              <li className="hover:text-[#ff7a00] cursor-pointer">
                <FaBookmark className="inline mr-2" /> My Bookmarks
              </li>
              <li className="hover:text-[#ff7a00] cursor-pointer">
                <FaHistory className="inline mr-2" /> My History
              </li>
            </ul>
          </div>
        </div>
      </div>
    </aside>


      {/* Main Content */}
      <main className="relative w-full md:w-5/6 p-4 md:p-10 bg-gradient-to-b from-[#fdfdfd] to-[#eef5f9] overflow-hidden">
      {/* Decorative bubbles */}
      <div className="absolute top-[-60px] left-[-40px] w-72 h-72 bg-[#ff7a00]/10 rounded-full blur-3xl z-0" />
      <div className="absolute top-[-60px] right-[-40px] w-72 h-72 bg-[#ff7a00]/10 rounded-full blur-3xl z-0" />
      <div className="absolute top-[30%] right-[-60px] w-96 h-96 bg-[#066a75]/10 rounded-full blur-2xl z-0" />
      <div className="absolute bottom-[-80px] left-1/3 w-80 h-80 bg-[#ff7a00]/20 rounded-full blur-3xl z-0" />

      <button
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        className="md:hidden fixed top-4 left-4 z-50 text-white bg-[#044f5c] p-2 rounded-md shadow-lg"
      >
        {mobileMenuOpen ? <FaTimes /> : <FaBars />}
      </button>
      <div className="bg-gradient-to-r from-[#055862] to-[#ff7a00] text-white p-6 rounded-xl shadow-[0_10px_25px_rgba(255,122,0,0.2)] mb-10 flex items-center justify-between hover:shadow-[0_12px_28px_rgba(255,122,0,0.4)] transition-shadow">

        {/* Left section: logo + welcome text */}
        <div className="flex items-center gap-4">
          <Link to="/">
            <img
              src="/logo.png"
              alt="iDisKover Logo"
              className="h-16 w-auto drop-shadow-xl rounded-xl hover:scale-105 transition"
            />
          </Link>
          <div>
            <h2 className="text-xl font-semibold">Welcome back, <span className="font-bold">Jagannath!</span></h2>
            <p className="text-sm text-white/90">Continue where you left off — your library is growing smarter.</p>
          </div>
        </div>

        {/* Right section: Profile image */}
        <div className="relative ml-2 md:ml-0" ref={profileRef}>
          <button onClick={() => setMenuOpen(prev => ({ ...prev, profile: !prev.profile }))} className="focus:outline-none">
            <img
              src="/testimonials/user4.jpg"
              alt="Profile"
              className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-white shadow-md hover:scale-105 transition-transform"
            />
          </button>

          {menuOpen.profile && (
            <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-[#1f2937] rounded-lg shadow-xl z-50 text-sm text-gray-700 dark:text-gray-200 overflow-hidden">
              <a href="/profile" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">👤 Profile Settings</a>
              <a href="/preferences" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">⚙️ Preferences</a>
              <a href="/change-password" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">🔒 Change Password</a>
              <a href="/logout" className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700">🚪 Logout</a>
            </div>
          )}
        </div>
      </div>


        <section className="mb-10">
          <h1 className="text-lg md:text-2xl font-bold text-[#055862] mb-4">
            <Typewriter
              options={{
                strings: [
                  'Search, and access millions of digital resources.',
                  'Explore eBooks, journals, multimedia, and more.',
                  'Start your academic journey with iDisKover.'
                ],
                autoStart: true,
                loop: true,
                delay: 50
              }}
            />
          </h1>
        </section>



        <section className="top-20 z-10 bg-white p-6 rounded-xl shadow-lg border border-gray-200 mb-6">
          <div className="flex flex-wrap gap-4 mb-4">
            {filters.map((filter) => (
              <label key={filter} className={`text-sm px-3 py-1 rounded-full cursor-pointer border transition ${
                selectedFilters.includes(filter)
                  ? 'bg-[#ff7a00] text-white border-[#ff7a00]'
                  : 'bg-white text-[#055862] border-gray-300 hover:bg-gray-100'
              }`}>
                <input
                  type="checkbox"
                  checked={selectedFilters.includes(filter)}
                  onChange={() => toggleFilter(filter)}
                  className="mr-2 hidden"
                />
                {filter}
              </label>
            ))}
          </div>

          <div className="flex items-center border border-gray-300 rounded-lg px-4 py-3 shadow-inner">
            <FaSearch className="text-gray-400 mr-3" />
            <input
              type="text"
              placeholder="Search across books, journals, theses..."
              className="w-full outline-none text-gray-700 placeholder-gray-400"
            />
          </div>
        </section>

        <SubscribedResources resources={subscribedResources} />
        
        <br />
          {/* Stat block Snippet */}
          <section id="stats" className="bg-gradient-to-r from-[#055862] to-[#ff7a00] text-white py-12">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8">
              {stats.map((stat, idx) => (
                <div
                  key={idx}
                  className="group flex flex-col items-center justify-center gap-3 p-4 sm:p-6 rounded-xl bg-gradient-to-br from-white/10 via-white/5 to-transparent border border-white/20 shadow-md hover:shadow-xl hover:bg-white/20 transition duration-300 cursor-pointer"
                >
                  <div className="bg-white/20 p-4 rounded-full">
                    <div className="text-4xl sm:text-5xl group-hover:scale-110 group-hover:-rotate-3 transition duration-300">
                      {stat.icon}
                    </div>
                  </div>
                  <div className="text-2xl sm:text-3xl font-bold">
                    <CountUp
                      end={stat.value}
                      duration={2.5}
                      separator=","
                      enableScrollSpy
                      scrollSpyDelay={100}
                    />
                    +
                  </div>
                  <p className="text-sm sm:text-base">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>


        <br />


        <div className="mb-10">
          <h3 className="text-lg sm:text-xl font-bold text-[#055862] mb-4">
            Recently Accessed
          </h3>

          <div className="flex sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-4 overflow-x-auto sm:overflow-visible pb-2">
            {[1, 2, 3, 4].map((item) => (
              <div
                key={item}
                className="min-w-[240px] sm:min-w-0 bg-white rounded-xl shadow p-4 border hover:border-[#ff7a00] transition flex-shrink-0"
              >
                {/* Cover Image */}
                <div className="w-full h-40 rounded-lg overflow-hidden mb-3">
                  <img
                    src={`/covers/book${item}.jpg`} // Replace with your actual image paths
                    alt={`Book Title ${item}`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform"
                  />
                </div>

                {/* Book Info */}
                <h4 className="font-semibold text-[#055862] mb-1">
                  Book Title {item}
                </h4>
                <p className="text-sm text-gray-500">
                  Type: eBook · Accessed 2 days ago
                </p>
              </div>
            ))}
          </div>
        </div>




      {mobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-black bg-opacity-50 md:hidden" onClick={() => setMobileMenuOpen(false)}>
          <div
            className="absolute left-0 top-0 w-64 h-full bg-gradient-to-b from-[#044f5c] to-[#066a75] text-white p-6 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setMobileMenuOpen(false)}
              className="text-white mb-4"
            >
              <FaTimes />
            </button>

            {/* Your sidebar content here, reuse the same list/menu */}
            <div className="space-y-4">
              <div className="font-semibold">📚 Digital Library</div>
              <ul className="pl-8 text-sm space-y-2">
                <li className="hover:text-[#ff7a00] cursor-pointer">eBooks</li>
                <li className="hover:text-[#ff7a00] cursor-pointer">Journals</li>
                <li className="hover:text-[#ff7a00] cursor-pointer">Theses</li>
                <li className="hover:text-[#ff7a00] cursor-pointer">Pre-Prints</li>
                <li className="hover:text-[#ff7a00] cursor-pointer">Book Chapters</li>
                <li className="hover:text-[#ff7a00] cursor-pointer">Multimedia</li>
                <li className="hover:text-[#ff7a00] cursor-pointer">Conference Papers</li>
              </ul>

              <div className="font-semibold flex items-center gap-2 text-white">
                <FaDatabase className="text-white" />
                Databases
              </div>
              <ul className="pl-8 text-sm space-y-2">
                <li className="hover:text-[#ff7a00] cursor-pointer">J-Gate</li>
                <li className="hover:text-[#ff7a00] cursor-pointer">EBSCO</li>
                <li className="hover:text-[#ff7a00] cursor-pointer">ProQuest</li>
                <li className="hover:text-[#ff7a00] cursor-pointer">JSTOR</li>
              </ul>

              <div className="font-semibold flex items-center gap-2 text-white">
                <FaUser className="text-white" />
                My Account
              </div>
              <ul className="pl-8 text-sm space-y-2">
                <li className="hover:text-[#ff7a00] cursor-pointer">
                  <FaBookmark className="inline mr-2" /> My Bookmarks
                </li>
                <li className="hover:text-[#ff7a00] cursor-pointer">
                  <FaHistory className="inline mr-2" /> My History
                </li>
              </ul>

            </div>
          </div>
        </div>
      )}

        {/* Optional content results or recommendations */}
      </main>
    </div>
  );
}